@let view = dataView();
@let image = view.image;
@let headlines = view.headlines;
@let link = view.link;
@let linkButton = link?.label ? link : undefined;

<mat-card [class.linked]="link?.href" [class.only-image]="!headlines" class="card" matRipple uiPageBlockImpression>
  <div class="card-wrapper">
    <ng-container *ngTemplateOutlet="contentTeaserCard"></ng-container>
  </div>

  @if (link) {
    <a
      [attr.aria-label]="headlines?.headline || linkButton?.label || link?.href"
      [link]="link"
      class="card-link-overlay"
      uiContentLink
      uiPageBlockLinkClick
    ></a>
  }
</mat-card>

<ng-template #contentTeaserCard>
  @if (image) {
    <ui-image [class.only-image]="!headlines" [data]="image"></ui-image>
  }

  @if (headlines || linkButton) {
    <div class="wrapper">
      @if (headlines) {
        <mat-card-content class="button">
          <ui-headlines [data]="headlines" [level]="3"></ui-headlines>
        </mat-card-content>
      }

      @if (linkButton) {
        <mat-card-actions [class.only-image]="!headlines">
          <div class="button-wrapper center">
            <a [link]="linkButton" mat-stroked-button uiContentLink uiPageBlockLinkClick>
              {{ linkButton.label }}
            </a>
          </div>
        </mat-card-actions>
      }
    </div>
  }
</ng-template>
